export default {
    url: '/support',
    template: `
        <support></support>
    `
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/support/index.js